import { render, staticRenderFns } from "./BatchStaffLinkCheckResult.vue?vue&type=template&id=245433c4&"
import script from "./BatchStaffLinkCheckResult.vue?vue&type=script&lang=ts&"
export * from "./BatchStaffLinkCheckResult.vue?vue&type=script&lang=ts&"
import style0 from "./BatchStaffLinkCheckResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow,VSpacer})
